import {useWatch} from 'react-hook-form';

import {AdditionalNote, useVehicleFormContext} from '@dms/features/vehicle-forms-kit';

import {suffixTestId} from 'shared/web';

export function AdditionalInfoWidget() {
  const {baseTestId, formApi, control} = useVehicleFormContext();

  const note = useWatch({
    control,
    name: 'additionalNote',
  });

  return (
    <AdditionalNote
      onChange={(values) => formApi.setValue('additionalNote', values?.note ?? '')}
      data-testid={suffixTestId('additional-note', {'data-testid': baseTestId})}
      note={note ?? undefined}
    />
  );
}
